import React from "react";
import { Tab, Tabs } from "react-bootstrap";
import { Card, CardBody } from "../../../../_metronic/_partials/controls";
import DeploymentJobs from "./components/DeploymentJobs";
import DeploymentRTSPJobs from "./components/DeploymentRTSPJobs";

export default class DeploymentDetails extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      key: "deploymentJobs"
    };
  }

  setKey = key => this.setState({ key });

  handleTabChange = key => {
    this.setState({ key });
    this.props.history.push(`/admin/deploymentDetails/${key}Page`);
  };

  /**
   * Renders the DeploymentDetails component, which includes a Card with Tabs for
   * managing deployment jobs and RTSP jobs. The active tab is controlled by the
   * component's state. When a tab is selected, the active key in the state is updated,
   * and the URL is updated accordingly.
   *
   * @return {ReactElement} The rendered DeploymentDetails component.
   */
  render() {
    return (
      <Card className="example example-compact">
        <CardBody>
          <Tabs
            id="controlled-tab-example"
            activeKey={this.state.key}
            onSelect={this.handleTabChange}
            style={{ fontSize: "1.275rem", fontWeight: "500" }}
          >
            <Tab
              eventKey="deploymentJobs"
              title="Deployment Jobs"
              // Render the DeploymentJobs component in the deploymentJobs tab.
              // Pass the setKey function as a prop to the DeploymentJobs component.
            >
              <DeploymentJobs setKey={this.setKey} />
            </Tab>
            <Tab
              eventKey="deploymentRTSPJobs"
              title="Deployment RTSP Jobs"
              // Render the DeploymentRTSPJobs component in the deploymentRTSPJobs tab.
              // Pass the setKey function as a prop to the DeploymentRTSPJobs component.
            >
              <DeploymentRTSPJobs setKey={this.setKey} />
            </Tab>
          </Tabs>
        </CardBody>
      </Card>
    );
  }
}
